module.exports = __webpack_public_path__ + "static/media/Ski-Lifts-Logo-Footer.876091b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/images/Ski-Lifts-Logo-Footer.png
// module id = 1237
// module chunks = 0